import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import demoAgeIcon from '../../../images/insight360/demo-age-icon.png';
import demoChildrenIcon from '../../../images/insight360/demo-children-icon.png';
import demoEducationIcon from '../../../images/insight360/demo-education-icon.png';
import demoEmploymentIcon from '../../../images/insight360/demo-employment-icon.png';
import demoEthnicityIcon from '../../../images/insight360/demo-ethnicity-icon.png';
import demoGenderIcon from '../../../images/insight360/demo-gender-icon.png';
import demoIncomeIcon from '../../../images/insight360/demo-income-icon.png';
import demoMaritalStatusIcon from '../../../images/insight360/demo-marital-status-icon.png';
import demoPoliticalIcon from '../../../images/insight360/demo-political-icon.png';
import demoRaceIcon from '../../../images/insight360/demo-race-icon.png';
import demoRegionIcon from '../../../images/insight360/demo-region-icon.png';
import demoResidenceIcon from '../../../images/insight360/demo-residence-icon.png';
import { numberWithCommas } from '../../../util/CommonUtils';
import demoOccupationIcon from '../../../images/insight360/demo-occupation-icon.png';
import { Tooltip } from '@trendmicro/react-tooltip';

const iconComponents = [
  { id: 'demoAgeIcon', demoName: 'Age', selectedIcon: demoAgeIcon },
  {
    id: 'demoChildrenIcon',
    demoName: 'Children in Household',
    selectedIcon: demoChildrenIcon,
  },
  {
    id: 'demoEducationIcon',
    demoName: 'Education',
    selectedIcon: demoEducationIcon,
  },
  {
    id: 'demoEmploymentIcon',
    demoName: 'Employment Status',
    selectedIcon: demoEmploymentIcon,
  },
  {
    id: 'demoEthnicityIcon',
    demoName: 'Ethnicity',
    selectedIcon: demoEthnicityIcon,
  },
  { id: 'demoGenderIcon', demoName: 'Gender', selectedIcon: demoGenderIcon },
  {
    id: 'demoIncomeIcon',
    demoName: 'Household Income',
    selectedIcon: demoIncomeIcon,
  },
  {
    id: 'demoMaritalStatusIcon',
    demoName: 'Marital Status',
    selectedIcon: demoMaritalStatusIcon,
  },
  {
    id: 'demoPoliticalIcon',
    demoName: 'Political Outlook',
    selectedIcon: demoPoliticalIcon,
  },
  { id: 'demoRaceIcon', demoName: 'Race', selectedIcon: demoRaceIcon },
  {
    id: 'demoRegionIcon',
    demoName: 'Census Region',
    selectedIcon: demoRegionIcon,
  },
  {
    id: 'demoResidenceIcon',
    demoName: 'Residence',
    selectedIcon: demoResidenceIcon,
  },
  {
    id: 'demoOccupationIcon',
    demoName: 'Occupation',
    selectedIcon: demoOccupationIcon,
  },
];

class SalesCatalystDemoComparisionDetail extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { demoName: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  getToolTip = data => {
    let tooltip;
    if (data) {
      if (data.data) {
        tooltip = (
          <span style={{ whiteSpace: 'nowrap', border: 'black', color: 'black', fontSize: '11px' }}>
            <span className="sc-attitude-choice-level">{data.name}:&nbsp;</span><strong>{data.data.label}</strong><br />
            <span style={{ textAlign: 'left' }}>INDEX:&nbsp;<strong> {numberWithCommas(Math.round(data.data.value.index))}</strong><br /></span>
            REACH:&nbsp;<strong>{data.data.value.pct}</strong><br />
            SAMPLE:&nbsp;<strong> {numberWithCommas(Math.round(data.data.value.sample))}</strong><br />
            WEIGHTED:&nbsp;<strong> {numberWithCommas(Math.round(data.data.value.weighted))}</strong><br />
          </span>
        );
      } else {
        tooltip = (
          <span style={{ whiteSpace: 'nowrap', border: 'black', color: 'black', fontSize: '11px' }}>
            <span className="sc-attitude-choice-level">{data.name}:&nbsp;</span><strong>{'NA'}</strong><br />
            <span style={{ textAlign: 'left' }}>INDEX:&nbsp;<strong> {'NA'}</strong><br /></span>
            REACH:&nbsp;<strong>{'NA'}</strong><br />
            SAMPLE:&nbsp;<strong> {'NA'}</strong><br />
            WEIGHTED:&nbsp;<strong> {'NA'}</strong><br />
          </span>
        );
      }
    }
    return tooltip;
  }

  render() {
    return (
      <div>
        {this.props.demoDetail !== undefined && (
          <div>
            <div className="sc-demographic-comparision-float">
              <div>
                <div
                  className="sc-demographic-comparision-image-border demographic-float"
                  id="scDemographicFloatIcon"
                >
                  {this.getImageIcon(this.props.demoDetail.name) ===
                    undefined && <div className="imageblock" />}
                  {this.getImageIcon(this.props.demoDetail.name) !==
                    undefined && (
                      <Tooltip
                        tooltipClassName="sc-reactTooltip"
                        content={() => {
                          return this.getToolTip(this.props.demoDetail);
                        }}
                      >
                        <img
                          className="i360-demo-comparision-img"
                          src={this.getImageIcon(this.props.demoDetail.name)}
                          alt={this.props.demoDetail.name}
                        /></Tooltip>
                    )}
                </div>
                <div className="sc-demographic-float">
                  <div className="sc-demo-comparision-icon-labels">
                    <Tooltip
                      tooltipClassName="sc-reactTooltip"
                      leaveDelay={-2}
                      content={() => {
                        return this.getToolTip(this.props.demoDetail);
                      }}
                    >
                      <span>
                        {this.props.demoDetail.name !== undefined ? this.props.demoDetail.name : ''}
                      </span>
                    </Tooltip>
                  </div>
                  <div className="div-overflow">
                    <div className="">
                      <div className="sc-demo-comparision-data">
                        <Tooltip
                          tooltipClassName="sc-reactTooltip"
                          leaveDelay={-2}
                          content={() => {
                            return this.getToolTip(this.props.demoDetail);
                          }}
                        >
                          <span>
                            {this.props.demoDetail.data !== undefined
                              ? this.props.demoDetail.data.label
                              : 'N/A'}
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

}

function mapDispatchToProps() {
  return {
    // insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(SalesCatalystDemoComparisionDetail);
